import { ColumnConfig } from '../column-config';
import { StoreColumnExtractor } from '../extractors/store-column-extractor';
import { SeriesMapper } from '../series-mappers/series-mapper.interface';
import { TableDataTransform } from '../table-data-transform/table-data-transform';
import { ExtractorConfig } from './extractor-config';

export abstract class MultipleSeriesExtractionExtractorConfig extends ExtractorConfig {
	constructor(portfolioName: ColumnConfig<StoreColumnExtractor>, public readonly mappers: SeriesMapper[], TableDataTransform?: TableDataTransform) {
		super(portfolioName, TableDataTransform);
	}
}
